/**
 * 图表图层：展示「编辑数据」，点击打开图表数据编辑能力。
 */
import React from 'react';
import type { IShortcutMenuItemRenderArgs } from '@/plugins/shortcut-menu/type';
import { ShortcutToolbarChartEditItem } from '@/plugins/shortcut-menu/views/shortcut-toolbar-widgets';
import { LayerType } from '@/version-types';
import { type ChartLayer } from '../../../..';

export const chartEditDataShortcutItem = ({ framework, id, layer }: IShortcutMenuItemRenderArgs) => {
    if (layer.layerType !== LayerType.CHART) return null;

    const onChart = (e: React.MouseEvent) => {
        e.stopPropagation();
        const chartLayer = framework.service.registration.getInstance<ChartLayer>('ChartLayer');
        if (!chartLayer) {
            throw new Error('ChartLayer is not found');
        }
        chartLayer.enterEdit(id);
    };

    return <ShortcutToolbarChartEditItem onClick={onChart} />;
};
